import { storageRef } from "../config/firebase.js";

export const getUrlFromStorage = async url => {
  try {
    if (url === undefined) return "require('@/assets/logo.png')";
    if (url.includes("https")) return url;
    const src = await storageRef.child(url).getDownloadURL();
    return src;
  } catch (error) {
    return "require('@/assets/logo.png')";
  }
};
